import { generateURNByKind } from '@agilelab/plugin-wb-builder-common';
import {
  camelCaseToCapitalCase,
  compactCompoundEntityRef,
} from '@agilelab/plugin-wb-platform-common';
import { Entity } from '@mainstage/catalog-model';
import { ScopeEnum } from './ManageAssignmentsDrawer/types';

export function getLabelAndValue(entity: Entity) {
  return {
    name: entity.metadata.name,
    kind: entity.kind as ScopeEnum,
    description: entity.metadata.description ?? '',
    version: (entity?.spec?.mesh as any)?.version ?? undefined,
    value: generateURNByKind(entity.metadata.name, entity.kind, true),
    displayName:
      (entity.spec?.mesh as any)?.name ??
      entity.metadata.displayName ??
      camelCaseToCapitalCase(entity.metadata?.name),
    id: generateURNByKind(entity.metadata.name, entity.kind, true),
    ref: compactCompoundEntityRef({
      kind: entity.kind,
      name: entity.metadata.name,
      namespace: 'default',
    }),
  };
}
